export function getEnum(type, value){
    return enuns[type][value];
}

const enuns = {

    natureza_operacao: {
        1: 'Devolução',
        2: 'Venda',
        3: 'Troca'
    },
    
    status_pedido: {
        N: 'Aberto',
        E: 'Aberto',
        F: 'Fechado'
    }
}